module.exports = __webpack_public_path__ + "img/hourglass.7b1aab5f.svg";